import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/Home"; // El componente Home
import Login from "./components/Login"; // El componente Login

function App() {
  return (
    <Router>
      <Routes>
        {/* Rutas actualizadas con 'element' */}
        <Route path="/Home" element={<Home />} />
        <Route path="/Login" element={<Login />} />
        {/* Redirigir por defecto al login */}
        <Route path="/" element={<Login />} />
      </Routes>
    </Router>
  );
}

export default App;
